import React, { useEffect, useState } from 'react'
import PickupServiceImage from './Assets/PickupServiceImage.svg';
import MyCourses from '../../Components/MyCourses/MyCourses'
import { EnrolledCourseButtonsInfo } from '../../PageNames'
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { GetStudentCoursePackageFields, GetStudentTimeTableForTheEnrolledCourse, GetStudentUpdatePickupLocationRequests, UpdateStudentPickupLocationRequestStatus } from '../../Actions/CourseA';
import { GetPickedStudentFieldFromUsers } from '../../Actions/UserA';
import { GetLocalStorage } from '../../Helpers/LocalStorage/LocalStorage';
import { useNavigate } from 'react-router-dom';
import NoPickupServiceIncluded from './NoPickupService';
import UpdatePickupLocationPopup from './UpdatePickupLocationPopup';
import moment from 'moment';
import {  GetCourseNameA } from '../../Actions/StudentA';
import Tooltip from '@mui/material/Tooltip';

const PickupServiceComponentPage = () => {
    const { EnrollmentId } = useParams();
    console.log("EnrollmentId in PickupServiceComponentPage is:",EnrollmentId)
    const Dispatch = useDispatch()
    const navigate = useNavigate();
    const { enrolledCourseTimeTable, enrolledCoursePackageFields } = useSelector((Store) => Store.CourseReducer);
    const { PickedStudentField } = useSelector((store) => store.LoginSignupReducer);
    const { CourseName } = useSelector(Store => Store.StudentReducer);

    const UserId = GetLocalStorage("UserInfo")?.UserId;
    console.log("enrolledCourseTimeTable in PickupServiceComponentPage is:",enrolledCourseTimeTable)
    console.log("enrolledCoursePackageFields in PickupServiceComponentPage is:",enrolledCoursePackageFields)
    console.log("UserId in PickupServiceComponentPage is:",UserId)
    console.log("CourseName in ClassesSchedule is:",CourseName)
    console.log("CourseName?.courseName in ClassesSchedule is:",CourseName?.courseName)
    console.log("PickedStudentField is:",PickedStudentField?.PickedStudentField)
    const userPickedStudentField = PickedStudentField?.PickedStudentField;
    const [nextClass, setNextClass] = useState(null); // State to hold the next class
    const [studentAddress, setStudentAddress] = useState("");
    const [pickupServiceIncluded, setPickupServiceIncluded] = useState("");
    const [instituteAddress, setInstituteAddress] = useState("");
    const [institutePhoneNumber, setInstitutePhoneNumber] = useState("");

    const [pickupServiceOfferStatus, setPickupServiceOfferStatus] = useState("");
    const [updatePickupLocationPopup, setUpdatePickupLocationPopup] = useState(false);
    const [nextClassId, setNextClassId] = useState("");

    useEffect(() => {
        // Dispatching the action when the component mounts
        if(UserId){
            Dispatch(GetPickedStudentFieldFromUsers(UserId));
        }
    }, [Dispatch]); // Dependency array includes dispatch

    useEffect(() => {
        if (EnrollmentId) {
             Dispatch(GetStudentTimeTableForTheEnrolledCourse(EnrollmentId))
        }
      }, [Dispatch, EnrollmentId]);

      useEffect(() => {
        if (EnrollmentId) Dispatch(GetStudentCoursePackageFields(EnrollmentId))
      }, [Dispatch, EnrollmentId]);

      useEffect(() => {
        if (enrolledCoursePackageFields) {
            const PickupService = enrolledCoursePackageFields?.coursePackage?.PickupService;
            const instituteAddress = enrolledCoursePackageFields?.InstituteAddress;
            const institutePhone = enrolledCoursePackageFields?.InstitutePhoneNumber;

            console.log("PickupService is:",PickupService)
            setPickupServiceIncluded(PickupService)
            setInstituteAddress(instituteAddress)
            setInstitutePhoneNumber(institutePhone)
        }
      }, [Dispatch, enrolledCoursePackageFields]);

      useEffect(() => {
        if (enrolledCourseTimeTable) {
          // Extract the timetable and address from the data
          const { timetable, studentAddress } = enrolledCourseTimeTable;
          setStudentAddress(studentAddress);
    
          // Find the next class by filtering and sorting by date
          const upcomingClasses = timetable
            .map((classInfo) => ({
              ...classInfo,
              startDate: new Date(classInfo.startDate),
            }))
            .filter((classInfo) => classInfo.startDate > new Date())
            .sort((a, b) => a.startDate - b.startDate);
    
          if (upcomingClasses.length > 0) {
            setNextClass(upcomingClasses[0]); // Set the nearest upcoming class
            setNextClassId(upcomingClasses[0].EventId); // Save the EventId in state
          }
        }
      }, [enrolledCourseTimeTable]);

      const handleUpdatePickupZoneClick = () =>{
        setUpdatePickupLocationPopup(true)
      }

      const { enrolledStudentUpdateLocationRequest } = useSelector((Store) => Store.CourseReducer);
      console.log("enrolledStudentUpdateLocationRequest in PickupServiceComponentPage is:",enrolledStudentUpdateLocationRequest)
  
      const { CreatedAt = "", CurrentAddress = "", RequestedUpdateAddress = "", Status="" } = enrolledStudentUpdateLocationRequest || {};

      // Format date only if CreatedAt exists
      const formattedDate = CreatedAt ? moment(CreatedAt).format("MMM DD, YYYY") : "N/A";
      const hoursAgo = CreatedAt ? moment().diff(moment(CreatedAt), 'hours') : "N/A";

      useEffect(() => {
          // Dispatching the action when the component mounts
          if(UserId){
              Dispatch(GetStudentUpdatePickupLocationRequests(UserId, EnrollmentId));
          }
      }, [Dispatch]); // Dependency array includes dispatch

      const handleAction = (action) => {
        Dispatch(UpdateStudentPickupLocationRequestStatus(UserId,action,EnrollmentId))
        .then(() => {
           // Set a timeout to refresh the page after 5 seconds
           setTimeout(() => {
                window.location.reload();
           }, 5000);

        })
    };

    useEffect(() => {
          localStorage.removeItem("elapsedTime");
          localStorage.removeItem("remainingTime");
      }, []);

    // Determine if the timetable is available
    const isPickupAvailable = enrolledCourseTimeTable?.timetable?.length > 0;


    return (
        <>
            {(pickupServiceIncluded === "Yes" || pickupServiceOfferStatus==="Activated") ? (
            <div className='w-full'>
                <div className='flex flex-col justify-center items-center'>
                    <img src={PickupServiceImage} alt="pickup image" className='w-[300px] h-[300px] lg:w-[400px] lg:h-[400px] mt-[-10px]' />
                    <p className='font-bold text-[24px] lg:text-[28px] text-center w-[320px] lg:w-[500px] text-[#4C34AD] mt-[-20px]'>The Navigation System Will Work Once The Instructor Initiate Class.</p>
                    <p className='text-[16px] lg:text-[18px] text-center w-[320px] lg:w-[500px] mt-[15px]'>
                        You will be able to see instructor location and pickup location in the map once the instructor leave for the pickup zone.
                    </p>

                    {nextClass ? (
                        <>
                            <p className="text-[18px] text-center mt-[20px]">
                            Your next In-Vehicle class is on
                            </p>
                            <p className="text-[18px] text-center font-bold mt-[5px]">
                            {nextClass.startDate.toLocaleDateString()} |{" "}
                            {nextClass.startDate.toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit",
                            })}
                            </p>
                            <p className="text-[18px] text-center font-bold mt-[5px]">Class ID: {nextClassId}</p>
                            <p className="text-[18px] text-center font-bold mt-[5px]">
                            Pickup Zone
                            </p>
                            <p className="text-[18px] text-center font-bold mt-[5px]">
                            {studentAddress}
                            </p>
                        </>
                        ) : (
                        <p className="text-[18px] text-center mt-[20px]">
                            No upcoming classes found.
                        </p>
                        )}


                    {updatePickupLocationPopup && (
                        <UpdatePickupLocationPopup 
                         setUpdatePickupLocationPopup={setUpdatePickupLocationPopup}
                         enrolledCourseTimeTable={enrolledCourseTimeTable}
                         UserId={UserId}
                         EnrollmentId={EnrollmentId}
                         studentAddress={studentAddress} />
                    )}
                    <div className='flex justify-center items-center gap-[10px] lg:gap-[15px] mt-[30px]'>
                        {/* <button className='w-[150px] lg:w-[180px] h-[40px] text-[14px] lg:text-[16px] text-center text-[#4C34AD] rounded-[10px] font-bold cursor-pointer'
                        style={{
                            border: '1px solid #4C34AD'
                        }}
                        onClick={handleUpdatePickupZoneClick}
                    >
                            Update Pickup Zone
                        </button> */}

                        <Tooltip
                            title={!isPickupAvailable ? "It will be enabled once the classes are set" : ""}
                            arrow
                            placement="top"
                            disableHoverListener={isPickupAvailable} // Only show tooltip when disabled
                            >
                        <button
                            className={`w-[150px] lg:w-[180px] h-[40px] text-[14px] lg:text-[16px] text-center rounded-[10px] font-bold ${
                            isPickupAvailable
                                ? 'text-[#4C34AD] border-[#4C34AD] cursor-pointer'
                                : 'text-[#A0A0A0] border-[#4C34AD] bg-[#F0F0F0] cursor-not-allowed'
                            }`}
                            style={{
                            border: '1px solid',
                            }}
                            onClick={handleUpdatePickupZoneClick}
                            disabled={!isPickupAvailable}
                        >
                            Update Pickup Zone
                        </button>
                        </Tooltip>


                        <button className={`w-[150px] lg:w-[180px] h-[40px] text-[14px] lg:text-[16px] text-center rounded-[10px] text-[#FFFFFF] font-bold ${
                                userPickedStudentField
                                    ? 'bg-[#4C34AD] cursor-pointer'
                                    : 'bg-[#D7DAE2] cursor-not-allowed'
                            }`}
                            disabled={!userPickedStudentField} // Disable if false or null
                            onClick={() => navigate(`/track-instructor-location/${EnrollmentId}`)}
                        >
                            Track Instructor
                        </button>
                    </div>

                    {enrolledStudentUpdateLocationRequest && (
                    <div className="w-full flex justify-center items-center mt-[50px]">
                        <div className='w-[85%] flex flex-col px-[40px] py-[20px] shadow-[4px_5px_6px_#00000029] rounded-[10px]'
                        style={{
                            border:"1px solid #BCBCBC"
                        }}>
                            <p className='text-[24px] text-[#4C34AD] font-bold'>My Requests</p>
                            <div className='w-full flex justify-between mt-[30px]'>
                                <div className='flex flex-col'>
                                    <p className='text-[20px] text-[#4C34AD] font-bold'>Date</p>
                                    <p className='text-[16px] text-[#4C34AD] mt-[15px]'> Initiated {formattedDate}</p>
                                    <p className='text-[14px] text-[#4C34AD] mt-[5px]'>{hoursAgo} hours ago</p>
                                </div>

                                <div className='flex flex-col'>
                                    <p className='text-[20px] text-[#4C34AD] font-bold'>Current Pickup Zone</p>
                                    <p className='text-[16px] text-[#4C34AD] mt-[15px]'>{CurrentAddress}</p>
                                </div>

                                <div className='flex flex-col'>
                                    <p className='text-[20px] text-[#4C34AD] font-bold'>Requested Pickup Zone</p>
                                    <p className='text-[16px] text-[#4C34AD] mt-[15px] w-[300px]'>{RequestedUpdateAddress}</p>
                                </div>

                                    <div className='flex flex-col'>
                                    <p className='text-[20px] text-[#4C34AD] font-bold'>Status</p>
                                    <div className='flex justify-center items-center gap-[10px] lg:gap-[15px] mt-[15px]'>
                                        <button className='w-[100px] h-[40px] text-[14px] text-center text-[#4C34AD] rounded-[10px] font-bold cursor-pointer'
                                        style={{
                                            border: '1px solid #4C34AD'
                                        }}
                                        >
                                            {Status}
                                        </button>

                                    </div>
                                </div>

                                {Status !== "Withdrawn" && (
                                    <div className='flex flex-col'>
                                        <p className='text-[20px] text-[#4C34AD] font-bold'>Action</p>
                                        <div className='flex justify-center items-center gap-[10px] lg:gap-[15px] mt-[15px]'>
                                            <button className={`w-[100px] h-[40px] text-[14px] text-center rounded-[10px] bg-[#4C34AD] text-[#FFFFFF] font-bold cursor-pointer`}
                                            onClick={() => handleAction("Withdrawn")}
                                            >
                                                Withdraw
                                            </button>
                                        </div>
                                    </div>
                                )}
                              
                            </div>

                            <div className='mt-[15px]' style={{borderBottom:"1px solid #BCBCBC"}}></div>
                        </div>
                    </div>
                    )}
          
                </div>
            </div> 
            ) : (
                <NoPickupServiceIncluded UserId={UserId}
                setPickupServiceOfferStatus={setPickupServiceOfferStatus}
                EnrollmentId={EnrollmentId}
                nextClass={nextClass}
                studentAddress={studentAddress}
                nextClassId={nextClassId}
                userPickedStudentField={userPickedStudentField}
                instituteAddress={instituteAddress}
                institutePhoneNumber={institutePhoneNumber}
                 />
            )}
        </>
    )
}

const PickupService = () => {
    const { EnrollmentId } = useParams();
    console.log("EnrollmentId in PickupService is:",EnrollmentId)
    const Dispatch = useDispatch()
    const { CourseName } = useSelector(Store => Store.StudentReducer);

    useEffect(() => {
        if (EnrollmentId) {
             Dispatch(GetCourseNameA(EnrollmentId))
        }
      }, [Dispatch, EnrollmentId]);
    return(
        <MyCourses ButtonsInfo={EnrolledCourseButtonsInfo} PageName="PickupService" Component={PickupServiceComponentPage} DisplayName={CourseName?.courseName} />
    )
}

export default PickupService